import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types";

export interface SupabaseEnv {
  url: string;
  anonKey: string;
}

export interface PublicClientOptions {
  persistSession?: boolean;
}

/**
 * Browser/public client using the anon key. Access control belongs in RLS.
 * Admin keeps session persistence; public web can disable it for read-only CMS
 * and anonymous lead inserts.
 */
export function createPublicClient(
  env: SupabaseEnv,
  options: PublicClientOptions = {},
): SupabaseClient<Database> {
  if (!env.url || !env.anonKey) {
    throw new Error("Faltan variables de entorno de Supabase (SUPABASE_URL / SUPABASE_ANON_KEY).");
  }

  const persistSession = options.persistSession ?? true;

  return createClient<Database>(env.url, env.anonKey, {
    auth: { persistSession, autoRefreshToken: persistSession },
  });
}

/**
 * Service-role client. Use only in trusted server environments such as Edge
 * Functions. Never ship the service-role key to browser code.
 */
export function createServiceRoleClient(url: string, serviceRoleKey: string): SupabaseClient<Database> {
  if (!url || !serviceRoleKey) {
    throw new Error("Faltan SUPABASE_URL / SUPABASE_SERVICE_ROLE_KEY.");
  }
  return createClient<Database>(url, serviceRoleKey, {
    auth: { persistSession: false, autoRefreshToken: false },
  });
}
